export default {
  title: 'Utwórz {level}',
  helperText: 'To okno dialogowe umożliwia tworzenie nowych zasobów (o ile licencja na to pozwala).',
};
